/**
 * @auth 赖传峰
 * @date 2023/2/27
 * @desc https://mypikpak.com/#platform-card 在移动端禁用此锚点
 */
import {
  defineNuxtRouteMiddleware,
  navigateTo,
} from '#imports'
import isMobileInServerAndClient from '~/utils/isMobileInServerAndClient'

export default defineNuxtRouteMiddleware(to => {
  if (isMobileInServerAndClient() && to.hash === '#platform-card') {
    return navigateTo({ hash: undefined })
  }
})
